import React, { useEffect } from "react";
import { useParams } from 'react-router';
import { containerMiddlewareAdEPortoEnergy } from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from 'antd';
import { NewWidget } from "../../Atomics/NewWidget";
import { isEmpty } from "../../../../utils/hooks/isEmpty";
import { unitConvertArrayOfObject, unitConverterArrays } from "../../../../utils/hooks/unitConverter";

export const AverageElectricConsumption = ({ dataToFilter }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { data: consumptionWeekAverageData, isFetching: consumptionWeekAverageIsLoading, refetch: refetchConsumptionWeekAverageData } = useFetch(
    "consumption/week-average", "averageElectricConsumption",
    {
      id: id,
      startDate: dataToFilter?.startDate?.toISOString()?.split('.')[0],
      endDate: dataToFilter?.endDate?.toISOString()?.split('.')[0],
    }, null, null, containerMiddlewareAdEPortoEnergy);

  useEffect(() => {
    refetchConsumptionWeekAverageData();
  }, [dataToFilter]);

  return (
    <Row id="Average Consumption" gutter={[16, 16]}>
      <Col span={6}>
        <Flex gap={16} vertical='true'>
          <NewWidget data={{
            background: 'white',
            title: t('averageConsumption'),
            icon: 'Bolt',
            charts: [{
              height: '120px',
              chartType: 'bigNumberChart',
              isFetching: consumptionWeekAverageIsLoading,
              data: consumptionWeekAverageData?.data && !isEmpty(consumptionWeekAverageData?.data) ? getSerializeAverage(consumptionWeekAverageData?.data) : null
            }]
          }} />
          <NewWidget data={{
            background: 'white',
            title: t('maximumConsumption'),
            icon: 'Bolt',
            charts: [{
              height: '120px',
              chartType: 'bigNumberChart',
              isFetching: consumptionWeekAverageIsLoading,
              data: consumptionWeekAverageData?.data && !isEmpty(consumptionWeekAverageData?.data) ? getSerializedMax(consumptionWeekAverageData?.data) : null
            }]
          }} />
        </Flex>
      </Col>
      <Col span={18}>
        <div>
          <NewWidget data={{
            background: 'white',
            title: t('averageConsumptionDaysOfWeek'),
            icon: 'Bolt',
            charts: [
              {
                height: '316px',
                chartType: 'columnsChartApex',
                chartId: 'mixBarChartLineThree',
                isFetching: consumptionWeekAverageIsLoading,
                data: consumptionWeekAverageData?.data && !isEmpty(consumptionWeekAverageData?.data) ? getSerializedData(consumptionWeekAverageData?.data, t, dataToFilter) : null
              }
            ]
          }} />
        </div>
      </Col>
    </Row>
  )
};

const getSerializeAverage = (data) => {
  const arrayOfValues = Object.values(data.data);
  const sumOfValues = arrayOfValues.reduce((partialSum, a) => partialSum + a, 0);
  return { number: sumOfValues / arrayOfValues.length, unit: data?.unit, icon: 'Bolt' };
};

const getSerializedMax = (data) => {
  const arrayOfValues = Object.values(data.data)
  const max = Math.max(...arrayOfValues);
  return { number: max, unit: data?.unit, icon: 'Bolt' };
};

const getSerializedData = (data, t, dataToFilter) => {
  const daysOfTheWeek = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  // Criar um novo objeto com as chaves na ordem desejada
  const orderedObject = [];

  daysOfTheWeek.forEach(day => {
    // Adicionar os valores do objeto original no novo objeto com a ordem das chaves
    if (data?.data.hasOwnProperty(day)) {

      orderedObject.push(
        {
          x: t(day),
          y: data?.data[day]
        }
      );
    }
  });

  const { convertedResult, newUnit } = unitConvertArrayOfObject(orderedObject, "kWh");

  return {
    "series": [{
      "name": t("Consumption"),
      "data": convertedResult
    }],
    "categories": [],
    // "labels": keys,
    "xAxisType": null,
    "tooltip": null,
    "unit": newUnit,
    "columnWidth": 20,
    "xAxisLabel": null,
    "yAxisLabel": newUnit,
    yAxisLabelRotate: -90,
    "color": null,
    // tickAmount: 12,
    // markersSize: [0, 6],
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    // "showTooltipTitle": true,
    "hideLegend": true
  }
};